import { render, staticRenderFns } from "./step-micepec-records-list.vue?vue&type=template&id=cca71372"
import script from "./step-micepec-records-list.vue?vue&type=script&lang=js"
export * from "./step-micepec-records-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports